import { useCallback, useEffect } from 'react'
import { useParams } from 'react-router'
import { Onboardings } from '@/core/enums/onboardings'
import { useOnboarding } from '@/core/hooks/use-onboarding'
import { stepsSecondPage } from '../components/steps'

export const useUsuarioEdicaoSecondPageOnboarding = () => {
  const { setSteps, setOpen, save, canOpen } = useOnboarding(
    Onboardings.USUARIO_EDICAO_SECOND_PAGE
  )
  const params = useParams()

  const setNextStepAndOpen = useCallback(() => {
    if (params.id || !canOpen) return
    setSteps?.([stepsSecondPage(save)[1]])
    setOpen()
  }, [params.id, canOpen, setSteps, save, setOpen])

  useEffect(() => {
    if (canOpen) {
      // se o usuario estiver editando um usuario existente e não fez o onboarding ainda, carrega todos os steps
      // caso contrario carrega apenas o primeiro, o segundo será carregado dinamicamente ao selecionar opções
      if (params.id) {
        setSteps?.(stepsSecondPage(save))
      } else {
        setSteps?.([stepsSecondPage()[0]])
      }
      setOpen()
    }
  }, [canOpen, params.id, save, setOpen, setSteps])

  return { setNextStepAndOpen }
}
